import {useToast as useChakraToast, UseToastOptions} from '@chakra-ui/react'
import {dequal} from 'dequal/lite'
import {useEffect, useState} from 'react'

const defaultOptions: UseToastOptions = {
  duration: 10_000,
  isClosable: true,
  position: 'bottom-right',
  status: 'success',
  variant: 'solid'
}

/**
 * Common `useToast` with our default options.
 *
 * Note the object returned by `useChakraToast` is not stable: https://github.com/chakra-ui/chakra-ui/issues/4230
 */
export default function useToast(options?: UseToastOptions) {
  const [storedOptions, setStoredOptions] = useState(options)
  const chakraToast = useChakraToast({...defaultOptions, ...options})
  const [toast, setToast] = useState(() => chakraToast)

  useEffect(() => {
    if (!dequal(options, storedOptions)) {
      setStoredOptions(options)
      setToast(() => chakraToast)
    }
  }, [chakraToast, options, storedOptions])

  return toast
}
